import { Controller } from 'stimulus';

class ReadMoreController extends Controller {
  initialize() {
    this.open = false;
  }

  static targets = [
    'content'
  ]

  static values = {
    moreText: String,
    lessText: String
  }

  toggle(e) {
    this.open === false? this.show(e) : this.hide(e);
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  show(e) {
    this.open = true;

    const target = e.target
    target.innerHTML = this.lessTextValue;
    this.contentTarget.style.setProperty('--read-more-line-clam-n', "'unset'");
  }

  hide(e) {
    this.open = false;

    const target = e.target
    target.innerHTML = this.moreTextValue;
    this.contentTarget.style.removeProperty('--read-more-line-clam-n');
  }
}

export default ReadMoreController;
